//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
export default {
  name: "Result",
  // 'isSuccess', 'title', 'description'
  props: {
    isSuccess: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      default: ''
    },
    description: {
      type: String,
      default: ''
    },
    content: {
      type: Boolean,
      default: true
    }
  }
};